import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiClosePosition } from "@/api";
import {
  ClosePositionResultCode,
  type ClosePositionRequest,
  type ClosePositionResponse,
} from "@/api/types";
import { showError } from "@/lib/toast";

/**
 * AI 平仓（/game/cex/ClosePosition）
 *
 * 入参：
 * - `strategyId`：订单/策略 ID
 */
export function useClosePosition() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      data: ClosePositionRequest
    ): Promise<ClosePositionResponse> => {
      console.log("useClosePosition", data);
      const res = await ApiClosePosition(data);
      console.log("useClosePosition", res.data);
      return res.data;
    },
    onError: error => {
      console.error("useClosePosition error", error);
      showError("平仓失败，请稍后重试");
    },
    onSuccess: data => {
      if (data.resultCode === ClosePositionResultCode.Success) {
        queryClient.invalidateQueries({ queryKey: ["closedOrderList"] });
        queryClient.invalidateQueries({ queryKey: ["openOrderList"] });
        queryClient.invalidateQueries({ queryKey: ["userCexPnlSummary"] });
        queryClient.invalidateQueries({ queryKey: ["balanceV2"] });
        return;
      }
      showError(data.resultMsg || "平仓失败");
    },
  });
}
